import { Visibility } from "@mui/icons-material";
import InsertDriveFile from "@mui/icons-material/InsertDriveFile";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import _ from "lodash";
import React, { Dispatch, SetStateAction } from "react";
import { DocumentAttrs, ProcessingAttrs } from "../../interfaces/orion";
import EditExtractionDialog from "../useDialogs/Orion/EditExtractionDialog";
import { useDialogs } from "../useDialogs/useDialogs";
import DocumentDisplay from "./DocumentDisplay";

interface ProcessingDetailsProps {
  processing: ProcessingAttrs;
  setDocument: Dispatch<SetStateAction<DocumentAttrs | undefined>>;
}

const ProcessingDetails: React.FC<ProcessingDetailsProps> = ({
  processing,
  setDocument,
}) => {
  const dialogs = useDialogs();
  const documentCores = _(processing.review!.analysis)
    .groupBy("document_id")
    .pickBy((_, docId) =>
      processing.documents.map((doc) => doc._id).includes(docId)
    )
    .value();
  if (!documentCores) {
    return <div>Votre processing est en cours</div>;
  } else {
    return (
      <Stack className="gap-2">
        {_.entries(documentCores).map(([documentId, cores]) => {
          const document = processing.documents.find(
            (doc) => doc._id === documentId
          )!;
          if (cores.length > 1) {
            return (
              <Paper
                sx={{
                  borderColor: "primary",
                  border: "1px solid",
                  borderRadius: 2,
                }}
                className="flex flex-col gap-2 p-2"
                key={document.name}
              >
                <div className="flex justify-between w-full items-center mb-2">
                  <div className="flex">
                    <InsertDriveFile className="text-gray-400" />
                    <Typography className="ml-2 font-bold">
                      {document.name}
                    </Typography>
                  </div>
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      setDocument(document);
                    }}
                  >
                    <Visibility />
                  </IconButton>
                </div>
                {cores.map((coreResult) => {
                  const coreIdx = processing.review!.analysis.findIndex(
                    (core) => core === coreResult
                  );
                  const validation =
                    processing.review!.validation?.document_validations[
                      coreIdx
                    ];
                  return (
                    <DocumentDisplay
                      key={coreIdx}
                      coreResult={coreResult}
                      validation={validation}
                      toEdit={() => {
                        dialogs.open(EditExtractionDialog, {
                          processing,
                          coreIdx,
                          document,
                        });
                      }}
                    />
                  );
                })}
              </Paper>
            );
          } else {
            const coreResult = cores[0];
            const coreIdx = processing.review!.analysis.findIndex(
              (core) => core === coreResult
            );
            const validation =
              processing.review!.validation?.document_validations[coreIdx];
            return (
              <DocumentDisplay
                key={document.name}
                title={document.name}
                coreResult={coreResult}
                validation={validation}
                setPdf={() => {
                  setDocument(document);
                }}
                toEdit={() => {
                  dialogs.open(EditExtractionDialog, {
                    processing,
                    coreIdx,
                    document,
                  });
                }}
              />
            );
          }
        })}
      </Stack>
    );
  }
};

export default ProcessingDetails;
